/**
 * This function rounds a number to a specified precision.
 * It takes two parameters: `value` (the number to round) and `precision`
 * @param value number to round
 * @param precision precision to round to
 * @description This function rounds a number to a specified precision.
 * @returns rounded number
 *
 * @example
 * roundOf(123.4567, 2) // returns 123.46
 */
export function roundOf(value: number, precision: number = 2): number {
  try {
    return Number(value.toFixed(precision))
  } catch {
    return value
  }
}
